import {
  IMockProps,
  ErrorResponseCodeType,
  MockServiceType,
  Mocks,
} from '../../Core';
import { ENDPOINT_API_PATH, CODE_ERRORS } from '../../Apis/UploadFileS3Api';
import {
  CategoryUploadType,
  UploadFileS3ServiceRequestType,
} from '../../Types/UploadFileS3.types';

/** Mocks de Sucesso */
const mocksSuccess: IMockProps[] = [];

/** Mocks de Erro */
let mocksErrors: IMockProps[] = [];

const generateSuccess = (category: string): IMockProps => {
  return {
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        category,
        extension: 'jpg',
        file: 'file',
      },
    },
    configResponse: {
      status: 200,
      data: {
        fileUrl: `archive.smiles.com.br/${category}/2021-10-29/ae6f27fe7b60169e45cd5045e06c30e9169513f0.jpg`,
      },
    },
  };
};

const generateDefaultErrors = (category: string): IMockProps[] => {
  return CODE_ERRORS.map(
    (error: ErrorResponseCodeType<null>, index: number): IMockProps => {
      return {
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body: {
            category,
            extension: 'jpg',
            file: `error-${index}`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
        },
      };
    },
  );
};

for (const category of Object.values(CategoryUploadType)) {
  mocksSuccess.push(generateSuccess(category));
  mocksErrors = mocksErrors.concat(generateDefaultErrors(category));
}

export const mocksService: MockServiceType<UploadFileS3ServiceRequestType>[] =
  mocksSuccess.map((request) => ({
    label: `[Sucesso] - ${JSON.stringify(request.configRequest.body.category)}`,
    value: request.configRequest.body,
  }));

const allMocks: IMockProps[] = mocksSuccess.concat(mocksErrors);

Mocks.getInstance().addAll(allMocks);
